import Store from "../store";
import _ from "lodash";

const addACFData = (post, additionalState = {}) => {
    if (!post || !post.ID) return null;

    const state = Store.getState();
    const related = _.get(state, `page.related[${post.ID}]`) || {};

    const additionalRelated =
        _.get(additionalState, `related[${post.ID}]`) || {};
    const merged = {
        ...post,
        ...related,
        ...additionalRelated,
    };
    return merged;
};

export default addACFData;
